export default "__VITE_ASSET__Ck4Q6ncv__"